import React, { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Box, Button, Grid, Typography } from '@material-ui/core'

import {
  BarChart,
  BaseDialog,
  DashboardChartPaper,
  DashboardTable,
} from 'components'

import helpers from 'helpers'

import theme from 'theme'
import useStyles from './styles'
import constants from 'constants/index'

const TreatedData = ({ isLoading = false, treatedData = {} }) => {
  const [openDialog, setOpenDialog] = useState(false)

  const {
    TREATED_DATA_TABLE,
    TREATED_DATA_TITULAR_CATEGORY_TABLE,
    TREATED_DATA_BY_DATA_TYPE_TABLE,
    TREATED_DATA_BY_DATA_TYPE_OPTIONS,
  } = constants.dataIntelligence
  const { DEFAULT_DATA_TYPE_LABELS } = constants.dataCollected

  const { mountTreatedDataRows } = helpers.dataIntelligence

  const classes = useStyles()

  const dataOptions = treatedData?.dataOptions?.slice(0, 6)
  const dataOptionNames = dataOptions?.map((item) => item?.titularCategory)
  const dataOptionsSeries = Object.entries(DEFAULT_DATA_TYPE_LABELS).map(
    ([typeId, label]) => ({
      name: label,
      data: dataOptions?.map(
        (opt) =>
          opt?.dataTypes?.find((dt) => dt?.dataType === Number(typeId))
            ?.quantity || 0,
      ),
    }),
  )

  const handleOpenDialog = () => setOpenDialog((prevState) => !prevState)

  const dataTypeOptions = mountTreatedDataRows(
    treatedData?.dataOptions,
    TREATED_DATA_BY_DATA_TYPE_OPTIONS,
    'titularCategory',
  )

  return (
    <Box display="flex" flexDirection="column" gridGap={theme.spacing(2)}>
      <Typography variant="h5" color="primary">
        Dados tratados
      </Typography>
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardTable
            emptyMessage="Nenhum dado tratado encontrado."
            rows={treatedData?.dataCollected}
            columns={TREATED_DATA_TABLE}
            isLoading={isLoading}
            hasPaper
            tableHeadProps={{ className: classes.tableHead }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardTable
            emptyMessage="Nenhuma categoria de titular encontrada."
            rows={treatedData?.titularCategories}
            columns={TREATED_DATA_TITULAR_CATEGORY_TABLE}
            isLoading={isLoading}
            hasPaper
            tableHeadProps={{ className: classes.tableHead }}
          />
        </Grid>
        <Grid
          item
          xs={12}
          className={clsx(classes.gridItem, { [classes.isLoading]: isLoading })}
        >
          <DashboardChartPaper
            title="Tipos de dados por categoria de titular"
            subtitle="Distribuição dos diferentes tipos de dados entre as categorias de titulares."
            isLoading={isLoading}
          >
            <Box display="flex" flexDirection="column" p={2}>
              <BarChart
                names={dataOptionNames}
                series={dataOptionsSeries}
                colors={[
                  theme.palette.tertiary.main,
                  theme.palette.dashboard.chart.primary.pending,
                  theme.palette.dashboard.chart.primary.inProgress,
                  theme.palette.dashboard.chart.primary.revision,
                ]}
                showLabels
                opacity={1}
                categoryProps={{
                  ...theme.typography.caption,
                }}
                noDataText="Nenhum dado encontrado."
              />
              <Box>
                <Button onClick={handleOpenDialog}>Ver Mais</Button>
              </Box>
            </Box>
          </DashboardChartPaper>
        </Grid>
      </Grid>
      <BaseDialog
        open={openDialog}
        setOpen={setOpenDialog}
        title="Tipos de dados por categoria de titular"
        dialogSize="md"
        closeButtonText="Fechar"
        fullWidth
      >
        <Box>
          <DashboardTable
            emptyMessage="Nenhuma categoria de titular encontrada."
            rows={dataTypeOptions}
            columns={TREATED_DATA_BY_DATA_TYPE_TABLE}
            isLoading={isLoading}
            hasPaper
            containerProps={{ className: classes.container }}
            tableHeadProps={{ className: classes.tableHead }}
          />
        </Box>
      </BaseDialog>
    </Box>
  )
}

TreatedData.propTypes = {
  isLoading: PropTypes.bool,
  treatedData: PropTypes.object,
}

export default TreatedData
